export const getConfig = () => {
  if (window.__APP_CONFIG__) {
    return {
      ENV: window.__APP_CONFIG__.ENV,
      APP_NAME: window.__APP_CONFIG__.APP_NAME,
      SERVER_TIME: window.__APP_CONFIG__.SERVER_TIME,
      CLIENT_ID: window.__APP_CONFIG__.CLIENT_ID,
      TENANT: window.__APP_CONFIG__.TENANT,
      SENTRY_DSN: window.__APP_CONFIG__.SENTRY_DSN,
      API_ID: window.__APP_CONFIG__.API_ID,
      STOCK_PRICE_TTL: window.__APP_CONFIG__.STOCK_PRICE_TTL,
      BACKEND_URL: window.__APP_CONFIG__.BACKEND_URL,
      FRONTEND_URL: window.__APP_CONFIG__.FRONTEND_URL,
    };
  } else {
    throw new Error(
      "App configuration is not available. Ensure the app is properly configured. [config.js]"
    );
  }
};
